import ExchangeNewPortfolioTable from "../portfolio/portfolio-section/ExchangeNewPortfolioTable";
import { useSelector } from "react-redux";
import ExchangePortfolioTableActionButtons from "../portfolio/portfolio-section/ExchangePortfolioTableActionButtons";

function ExchangePortfolioTable() {
  const {
    exchangeState: {
      portfolioLoading,
      portfolioData,
      selectedPortfolioExchange,
      portfolioError,
      integratedDataLoading,
    },
  } = useSelector((state) => state);

  return (
    <div>
      <ExchangePortfolioTableActionButtons />
      <ExchangeNewPortfolioTable
        loading={portfolioLoading || integratedDataLoading}
        data={portfolioData}
        exchange={selectedPortfolioExchange}
        error={
          !!portfolioError
            ? portfolioError?.STATUS_CODE === 421
              ? "API key is expired or invalid"
              : "Failed to fetch portfolio data. Please try again."
            : ""
        }
        height={300}
      />
    </div>
  );
}

export default ExchangePortfolioTable;
